import client from '@/shared/apis/client'

import {
  type KnowledgeAskResult,
  type KnowledgeConversation,
  type KnowledgeConversationDetail,
  type KnowledgeExchange,
} from '../types/knowledge'

const BASE_URL = '/api/knowledge'

// 一覧が返す会話数の上限。**back の `crud.HISTORY_LIMIT` と対**で、値がずれると
// 「これ以上ある」の判定が狂う (少なく持つと出ない、多く持つと常に出る)。
// 統合はしない — back は返す量の制限、こちらは溢れたことを画面に出す判定で用途が違う。
export const KNOWLEDGE_HISTORY_LIMIT = 100

// 質問 1 件の字数上限。**back の `views.QUESTION_MAX_CHARS` と対**。
// 実際に拒むのは back で (API は直接叩ける)、こちらは打ち終えてから 400 を見せない
// ための歯止め。値がずれると、打てたのに送れない (こちらが大きい) か、
// 打てる範囲が理由なく狭い (こちらが小さい) かのどちらかになる。
export const KNOWLEDGE_QUESTION_MAX_CHARS = 2000

export const getKnowledgeConversations = async (): Promise<
  KnowledgeConversation[]
> => {
  const response = await client.get<KnowledgeConversation[]>(
    `${BASE_URL}/conversations/`
  )
  return response.data
}

export const getKnowledgeConversation = async (
  conversationId: string
): Promise<KnowledgeConversationDetail> => {
  const response = await client.get<KnowledgeConversationDetail>(
    `${BASE_URL}/conversations/${conversationId}/`
  )
  return response.data
}

// 新規会話の開始。会話の作成と最初の回答生成を 1 往復で済ませる。
export const startKnowledgeConversation = async (
  question: string
): Promise<KnowledgeAskResult> => {
  const response = await client.post<KnowledgeAskResult>(
    `${BASE_URL}/conversations/`,
    { question }
  )
  return response.data
}

export const askKnowledgeQuestion = async (
  conversationId: string,
  question: string
): Promise<KnowledgeExchange> => {
  const response = await client.post<KnowledgeExchange>(
    `${BASE_URL}/conversations/${conversationId}/messages/`,
    { question }
  )
  return response.data
}
